// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__JFIdy","info":"Panel_info__UYT9g","btns":"Panel_btns__7zjbS","button":"Panel_button__GL2QJ"};